var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24CAA5",
    fillRule: "nonzero",
    d: "M13.538 0c-.679 0-1.23.551-1.23 1.23v4.924h2.461V1.23C14.77.55 14.218 0 13.54 0m1.231 6.154v15.49l2.822-2.822a1.23 1.23 0 1 1 1.74 1.74l-4.922 4.924a1.227 1.227 0 0 1-1.74 0l-4.924-4.924a1.23 1.23 0 1 1 1.74-1.74l2.823 2.822V6.154H2.462A2.46 2.46 0 0 0 0 8.615v20.923A2.46 2.46 0 0 0 2.462 32h22.153a2.46 2.46 0 0 0 2.462-2.462V8.615a2.46 2.46 0 0 0-2.462-2.461z"
  })));
};
export default SvgDownloadIcon;